import { location, matchMedia } from 'window';

import _ from 'lodash';
import ko from 'rgs-knockout';
import menuApi from 'app-my-navigation/api';

import { default as browserDetector } from 'browser-type-detector';

import Model from './model';

import template from '../templates/template.html';


export default class MyRgsLoginController {
	constructor (options) {
		const {view, params} = _.defaults({...options}, {
			view: undefined,
			params: {},
		});

		this.isPwaMode = browserDetector.isStandalonePwa();

		this._model = new Model({
			logContext: params.logContext,
			prefilling: params.prefilling,
			dictionaries: params.dictionaries,
			config: params.config,
			isPwaMode: this.isPwaMode,
		});

		this._model.on('authSuccess', this._authSuccess.bind(this));
		this._model.on('registrationMode', () => {
			this._model.registrationMode(true);
		});

		render(view, {data: this._model, html: template});
	}

	async _authSuccess () {
		let redirectUrl = '';

		const menuItems = await menuApi.getMenuItemsAsync();
		if (menuItems && menuItems.Items) {
			const redirectItem = menuItems.Items
				.find(mi => mi.Attributes.some(attr => attr.Key === 'loginRedirect'));
			if (redirectItem && redirectItem.Url) {
				redirectUrl = redirectItem.Url;
			}

			const isMobileAlikeDevice = matchMedia('(max-width: 619px)').matches;
			if (isMobileAlikeDevice) {
				const alternativeRedirectItem = menuItems.Items
					.find(mi => mi.Attributes
						.some(attr => attr.Key === 'loginRedirectMobileAlternate'));
				
				if (alternativeRedirectItem && alternativeRedirectItem.Url) {
					redirectUrl = alternativeRedirectItem.Url;
				}
			}
		}

		// Default lk url
		if (!redirectUrl) {
			redirectUrl = _(location.pathname)
				.split('/')
				.initial()
				.concat('private/')
				.join('/');
		}

		if (redirectUrl.includes('#')) {
			location.href = redirectUrl;
		} else {
			location.pathname = redirectUrl;
		}
	}
}


function render (view, {html, data}) {
	ko.applyBindingsToNode(view, {
		template: {
			html: html(),
			data: data,
		},
	});
}
